import React from "react";
import contextProvider from "../../../contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col, Label, ButtonGroup } from "reactstrap";
import { isEqual } from "lodash";
import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";

import Section from "../../../_L1_components/Layout/Section";
import Panel from "../../../_L1_components/Layout/Panel";
import ReactOActionBar from "../../../_L1_components/Elements/ReactOActionBar";
import ReactOModal from "app/_L1_components/Elements/ReactOModal";
import ReactOForm from "../../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../../_L1_components/Elements/ReactOFormInput";
import ReactOButton from "../../../_L1_components/Elements/ReactOButton";

class ProbeSetupGeneral extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
    };
    super(props, initState);
  }

  uploadProbePhotos(photo_files, cb) {
    if (photo_files.length) {
      this.setState(
        {
          //	probe_photos_loading: true
        },
        () => {
          this.apiStore.fire("upload_probe_photos", {
            data: {
              probeuid: this.props.match.params.probeuid,
              files: photo_files,
            },
            ___onSuccess: (status, data) => {
              this.setState(
                {
                  //	probe_photos_loading: false
                },
                () => {
                  //	this.loadData();
                  if (cb) {
                    cb(status, data);
                  }
                }
              );
            },
          });
        }
      );
    } else {
      if (cb) {
        cb("OK", {});
      }
    }
  }

  deleteProbePhoto(photo_id, cb) {
    if (photo_id !== undefined) {
      this.setState(
        {
          probe_photos_loading: true,
        },
        () => {
          this.apiStore.fire("delete_probe_photos", {
            data: {
              probeuid: this.props.match.params.probeuid,
              photoid: photo_id,
            },
            ___onSuccess: (status, data) => {
              this.setState(
                {
                  probe_photos_data: data,
                  probe_photos_loading: false,
                },
                () => {
                  if (cb) {
                    cb(status, data);
                  }
                }
              );
              /*this.setState({
							probe_photos_loading: false
						}, () => {
							this.callsSet.call(['get_probe_photos'], {
								on_success: (status, datas) => {
									this.setState({
										probe_photos_data: datas[0].data
									}, () => {
										if (cb) {
											cb(status, data);
										}
									})
								}
							});
						})*/
            },
          });
        }
      );
    } else {
      if (cb) {
        cb("OK", {});
      }
    }
  }

  rotateImage(image, cb) {
    this.setState({ probe_photos_loading: true }, () => {
      this.apiStore.fire("rotate_img", {
        data: {
          probeuid: this.props.match.params.probeuid,
          image,
        },
        ___onSuccess: (status, data) => {
          this.setState({ probe_photos_loading: false, imageHash: Date.now() });
          // this.forceUpdate();
        },
      });
    });
  }

  setFavouriteProbePhoto(photo_id, cb) {
    if (photo_id !== undefined) {
      this.setState(
        {
          probe_photos_loading: true,
        },
        () => {
          this.apiStore.fire("set_favourite_probe_photos", {
            data: {
              probeuid: this.props.match.params.probeuid,
              photoid: photo_id,
            },
            ___onSuccess: (status, data) => {
              if (status == "OK") {
                this.setState(
                  (prev_state) => {
                    prev_state.probe_photos_data.forEach((_C_photo, _C_idx) => {
                      if (_C_photo.fav == 1) {
                        _C_photo.fav = 0;
                      }
                      if (_C_photo.filename == photo_id) {
                        _C_photo.fav = 1;
                      }
                    });
                    prev_state.probe_photos_loading = false;
                    return prev_state;
                  },
                  () => {
                    if (cb) {
                      cb(status, data);
                    }
                  }
                );
                /*this.setState({
								probe_photos_loading: false
							}, () => {
								this.callsSet.call(['get_probe_photos'], {
									on_success: (status, datas) => {
										this.setState({
											probe_photos_data: datas[0].data
										}, () => {
											if (cb) {
												cb(status, data);
											}
										})
									}
								});
							})*/
              }
            },
          });
        }
      );
    } else {
      if (cb) {
        cb("OK", {});
      }
    }
  }

  loadProbeSetup() {
    this.callsSet.call("get_probe_setup", {
      on_success: (_, datas) => {
        let preload_setup = datas[0];
        this.loadData(preload_setup);
      },
    });
  }

  loadData(preload_setup, cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        if (this.props.onConfLoad) {
          this.props.onConfLoad();
        }
        this.callsSet.call(["get_probe_photos"], {
          cb: () => {
            if (this.mounted) {
              this.setState({
                loading: false,
              });
            }
          },
          on_success: (status, source_datas) => {
            let datas = [...source_datas];
            // console.log("preload_setup 1 ->", preload_setup);
            datas.push(preload_setup);
            if (this.mounted) {
              this.setState({
                probe_photos_data: datas.find((value) => {
                  return value.call_id == "get_probe_photos";
                }).data,
              });
            }
            if (this.getAppContext().isCloud()) {
              if (this.mounted) {
                this._probe_setup_form.init({
                  name: datas.find((value) => {
                    return value.call_id == "get_probe_setup";
                  }).data.name,
                  conf: datas.find((value) => {
                    return value.call_id == "get_probe_setup";
                  }).data.management.measures_conf,
                  status: datas.find((value) => {
                    return value.call_id == "get_probe_setup";
                  }).data.management.probe_status,
                });
              }
            } else {
              this._probe_setup_form.init({
                name: datas.find((value) => {
                  return value.call_id == "get_probe_setup";
                }).data.name,
              });
            }
          },
          on_error: () => {},
        });
      }
    );
  }

  saveProbeSetup(data, cb) {
    //		console.log("DEBUG :: ProbeSetup _ saveProbeSetup");
    //		console.log(data);
    this.setState(
      {
        //	probe_name_save_loading: true
      },
      () => {
        if (this.getAppContext().isCloud()) {
          this.apiStore.fire("set_multi_setup", {
            data: {
              probeuid: this.props.match.params.probeuid,
              entry_path: {
                management: {
                  measures_conf: data.conf,
                  probe_status: data.status,
                },
                name: data.name,
              },
            },
            ___onSuccess: (status, data) => {
              this.setState(
                {
                  //	probe_name_save_loading: false
                },
                () => {
                  //	this.loadProbeSetup();
                  if (cb) {
                    cb(status, data);
                  }
                }
              );
            },
          });
        } else {
          this.apiStore.fire("set_multi_setup", {
            data: {
              probeuid: this.props.match.params.probeuid,
              entry_path: {
                name: data.name,
              },
            },
            ___onSuccess: (status, data) => {
              this.setState(
                {
                  //	probe_name_save_loading: false
                },
                () => {
                  //	this.loadProbeSetup();
                  if (cb) {
                    cb(status, data);
                  }
                }
              );
            },
          });
        }
      }
    );
  }

  /////////////////////////
  //	Lifecycle methods
  //
  // componentDidUpdate(prev_props) {
  //   console.log("prev_props", prev_props);
  //   console.log("state", this.state);
  // }

  onComponentDidMount() {
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this.callsSet = this.apiStore.newCallsSet({
      state_setter: this._getStateSetter(),
      calls_set: {
        get_probe_setup: {
          api_id: "get_probe_setup",
          set_state: false,
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        get_probe_setup_with_filter: {
          api_id: "get_probe_setup_with_filter",
          set_state: false,
          static_data: {
            probeuid: this.props.match.params.probeuid,
            entry_path: "name",
          },
        },
        get_probe_photos: {
          api_id: "get_probe_photos",
          set_state: false,
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
      },
    });
    // this.setState({loading: true})
    this.callsSet.call("get_probe_setup", {
      on_success: (_, datas) => {
        // console.log("datas[0]", datas[0]);
        let preload_setup = datas[0];
        if (this.props.location.state && isEqual(datas[0], this.props.location.state)) {
          // console.log("this.props.location.state ->", this.props.location.state);
          preload_setup = { ...this.props.location.state };
          this.loadData(preload_setup);
        } else {
          this.loadProbeSetup();
        }
      },
    });
  }

  onComponentWillUnmount() {
    this.mounted = false;
  }

  onRender() {
    return (
      <_LoadingWrapper loadingPlug={this.state.loading}>
        <Panel
          className="mb-4 rounded-bottom"
          //	header="GENERAL SETTINGS"
          style={{
            minHeight: "100px",
          }}
        >
          <ReactOForm
            onSubmit={this.saveProbeSetup.bind(this)}
            unsavedWarning={true}
            onControllerReady={(form_controller) => {
              this._probe_setup_form = form_controller;
            }}
            onFormWillSubmit={() => {
              this.setState({ loading: true });
            }}
            onFormDidSubmit={() => {
              this.loadProbeSetup();
            }}
          >
            {!this.state.loading ? (
              <>
                <Row>
                  <Col xs={12}>
                    <_LoadingWrapper
                    //	loadingPlug={this.state.probe_name_save_loading}
                    >
                      <ReactOFormInput
                        className="mb-3"
                        type="text"
                        data_key="name"
                        label="Probe name"
                        placeholder="Type probe name"
                        size="md"
                        default=""
                        required
                        validators={[
                          {
                            func: (value) => {
                              return /^.+$/i.test(value);
                            },
                            invalid_text: "Probe name cannot be empty",
                          },
                        ]}
                      />
                    </_LoadingWrapper>
                  </Col>
                </Row>

                {this.getAppContext().isCloud() ? (
                  <span>
                    <Row>
                      <Col xs={12} sm={6} lg={2}>
                        <ReactOFormInput
                          className="mt-1 mb-3 select-conf"
                          type="select"
                          disabled={
                            this.getAppContext().authHandler.getAccountData().SDmeasure !=
                            "yes"
                          }
                          data_key="conf"
                          label="Configuration"
                          // default='manual'
                          options={() => {
                            return [
                              { name: "Manual", value: "manual" },
                              { name: "Software Defined", value: "SD" },
                            ];
                          }}
                          // onOptionSelect={(form_ctrl, selected_value) => {
                          // 	form_ctrl.handleFormChange('conf-'+ data.prb_id, selected_value);
                          // }}
                        />
                      </Col>
                    </Row>

                    <div className="sub-title">
                      <p>
                        Besides "Manual" configuration, WiFiProbe supports the integration
                        with network management systems (CiscoPrime, Aruba WLAN/AirWave,
                        Meraki Cloud/Dashboard...) to automatically define the measures by
                        the WiFiProbes on the managed Access Points.
                      </p>
                    </div>

                    <Row>
                      <Col xs={12} sm={6} lg={2}>
                        <ReactOFormInput
                          className="mb-3 select-status"
                          size="md"
                          type="select"
                          data_key="status"
                          label="Probe status"
                          // default='deployed'
                          options={() => {
                            return [
                              { name: "Deployed", value: "deployed" },
                              { name: "Not deployed", value: "not_deployed" },
                              { name: "Maintenance", value: "maintenance" },
                            ];
                          }}
                          // onOptionSelect={(form_ctrl, selected_value) => {
                          // 	form_ctrl.handleFormChange('status-'+data.prb_id, selected_value);
                          // }}
                        />
                      </Col>
                    </Row>
                    <div className="sub-title">
                      <p>
                        Use "PROBE STATUS" to document the status of the device and group
                        them differently in "DASHBOARD/Probe list".
                        <br />
                        When the WiFiProbe configuration is automatic, the "PROBE STATUS"
                        also affects the type of notifications sent.
                      </p>
                    </div>
                    <Row>
                      <Col>
                        <_LoadingWrapper loadingPlug={this.state.probe_photos_loading}>
                          <Label>PROBE PHOTOS</Label>
                          <Section
                            className="mb-3"
                            designType="wide"
                            layoutManager="grid"
                            elementsPerRow={6}
                            gridSpacing={10}
                          >
                            {this.state.probe_photos_data
                              ? this.state.probe_photos_data.map((_C_photo, _C_idx) => {
                                  const hash = this.state.imageHash || "";
                                  return (
                                    <div key={_C_idx} style={{ position: "relative" }}>
                                      <div
                                        className={"bg-cover rounded"}
                                        style={{
                                          position: "relative",
                                          // zIndex: '1001',
                                          paddingBottom: "100%",
                                          background:
                                            "url(" +
                                            (this.getAppContext()
                                              .getApiStoreService()
                                              .getCluster() +
                                              this.getAppContext().conf.API_PATH +
                                              "/utils/prbphotostream/" +
                                              this.props.match.params.probeuid +
                                              "/" +
                                              _C_photo.filename +
                                              "/1?token=" +
                                              this.getAppContext().authHandler.getToken() +
                                              `&hs=${hash}`) +
                                            ") center center no-repeat",
                                        }}
                                      />
                                      <div
                                        className="p-1"
                                        style={{
                                          position: "absolute",
                                          top: "0",
                                          bottom: "20px",
                                          width: "100%",
                                          zIndex: "1002",
                                        }}
                                      >
                                        <ButtonGroup>
                                          <ReactOButton
                                            //	straight
                                            icon="cancel"
                                            color="danger"
                                            size="sm"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              this._probePhotoDelete_modal.open(_C_photo);
                                            }}
                                          />
                                          <ReactOButton
                                            //	straight
                                            icon={_C_photo.fav ? "star" : "star-outline"}
                                            color={_C_photo.fav ? "primary" : "light"}
                                            size="sm"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              this.setFavouriteProbePhoto(
                                                _C_photo.filename
                                              );
                                            }}
                                          />
                                          <ReactOButton
                                            //	straight
                                            icon="redo"
                                            color="light"
                                            size="sm"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              this.rotateImage(_C_photo.filename);
                                              // this._probePhotoDelete_modal.open(_C_photo);
                                            }}
                                          />
                                        </ButtonGroup>
                                      </div>
                                    </div>
                                  );
                                })
                              : null}
                          </Section>

                          <ReactOFormInput
                            className="mb-2"
                            type="upload"
                            size="md"
                            fileTypes={{
                              "image/jpeg": {},
                            }}
                            maxUploads={
                              this.state.probe_photos_data
                                ? 6 - this.state.probe_photos_data.length
                                : 0
                            }
                            onUpload={this.uploadProbePhotos.bind(this)}
                          />
                          <small className="text-muted d-flex align-items-center">
                            <span
                              className="icon-info mr-1"
                              style={{ fontSize: "130%" }}
                            />
                            You can upload up to 6 photos per probe
                          </small>
                        </_LoadingWrapper>
                      </Col>
                    </Row>
                  </span>
                ) : null}
                <Row>
                  <Col>
                    <ReactOActionBar align="right" padding="0">
                      <ReactOFormInput
                        type="submit"
                        value="Save"
                        color="primary"
                        icon="save"
                      >
                        Save
                      </ReactOFormInput>
                    </ReactOActionBar>
                  </Col>
                </Row>
              </>
            ) : null}
          </ReactOForm>
        </Panel>
        <ReactOModal
          modalId="unsavedWarning"
          size="md"
          onControllerReady={(modal_context) => {
            this._probePhotoDelete_modal = modal_context;
          }}
          header="Delete probe photo"
          body="Do you want to delete photo?"
          actions={[
            {
              text: "Cancel",
              color: "light",
              action: "close",
            },
            {
              text: "Delete",
              color: "danger",
              icon: "delete",
              action: (data) => {
                this._probePhotoDelete_modal.close();
                this.deleteProbePhoto(data.filename, () => {});
              },
            },
          ]}
        />
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(
  withRouter(ProbeSetupGeneral),
  //	withDefinedContext(ProbeSetupGeneral, 'ProbeSetupGeneral', context_exposed_methods),
  {
    define: null,
  }
);
